export default __webpack_public_path__ + "static/media/Me.7b959dd0.jpg";